import React from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
import Services from "../components/Sections/Services";
import AboutUs from "../components/Sections/AboutUs";
import Locations from "../components/Sections/Locations";
import Projects from "../components/Sections/Projects";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer";
import CookieConsent from "react-cookie-consent";
import { Link } from 'react-router-dom';

export default function Homepage() {
  return (
    <>
      <TopNavbar />
      <Header />
      <AboutUs />
      <Services />
      <Locations />
      <Projects />
      <Contact />
      <Footer />

      <CookieConsent
        location="bottom"
        buttonText="Einverstanden"
        cookieName="myAwesomeCookieName2"
        style={{ background: "#2B373B", fontSize: "12px" }}
        buttonStyle={{ color: "#4e503b", fontSize: "12px", borderRadius: "5px" }}
        expires={150}
      >
        Diese Webseite verwendet Cookies, um Ihnen ein optimales Online-Erlebnis bieten zu können. Durch die Nutzung dieser Webseite erklären Sie sich mit der Verwendung von Cookies einverstanden. 
        <Link to="/datenschutz" style={{ color: "white", textDecoration: "underline" }}>{'   '} Mehr infos</Link>
      </CookieConsent>
      {/* Legacy sections removed */}
    </>
  );
}

